import { Role } from '@caresend/types';
import update from 'immutability-helper';
import { getUserPath } from '../dataHelpers/user.js';
import { encryptUserID } from './user.js';
import { encryptData, getValueOnce } from '../environment/data/privateHelpers.js';

async function encryptOrder(order, creator) {
  var _a, _b, _c;

  const orderTransactions = order.transactions;
  const orderWithoutTransactions = update(order, {
    $unset: ['transactions']
  });
  const encryptedOrder = orderWithoutTransactions;
  if (orderTransactions) encryptedOrder.transactions = await encryptData(orderTransactions);
  let createdByRole = (_a = creator === null || creator === void 0 ? void 0 : creator.role) !== null && _a !== void 0 ? _a : null;
  let createdByID = (_b = creator === null || creator === void 0 ? void 0 : creator.id) !== null && _b !== void 0 ? _b : null;

  if (!createdByRole) {
    createdByID = (_c = order.createdBy) !== null && _c !== void 0 ? _c : null;
    if (!createdByID) throw Error('Order createdBy ID is required');
    createdByRole = await getValueOnce(getUserPath(createdByID, 'role'));

    if (createdByRole === Role.PATIENT) {
      encryptedOrder.createdBy = await encryptUserID(createdByID);
    }
  }

  return encryptedOrder;
}

export { encryptOrder };
